import * as types from '../../actionTypes';

export const requestUnpublish = (auditModelId: string, meta: Record<string, unknown> = {}) => ({
  type: types.UNPUBLISH,
  payload: auditModelId,
  meta,
});

export const displayUnpublishModal = (auditModelId: string) => ({
  type: types.DISPLAY_UNPUBLISH_MODAL,
  payload: auditModelId,
});

export const hideUnpublishModal = () => ({
  type: types.HIDE_UNPUBLISH_MODAL,
});
